import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
})
export class PageHeaderComponent {
  @Input() header?: string;
  @Input() loading = false;
  @Input() showBackButton = false;
  constructor(private readonly location: Location) {}

  protected getLocation() {
    return this.location;
  }

  protected getPageHeader(): string | undefined {
    return this.header;
  }

  protected isLoading(): boolean {
    return this.loading;
  }

  protected isBackButtonVisible(): boolean {
    return this.showBackButton;
  }
}
